// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loverly-landing-page-hero .lp-hero{height:560px}.loverly-landing-page-hero .landig-hero-lead,.loverly-landing-page-hero .landing-hero-title{margin-bottom:1rem;margin-top:0}@media (max-width:992px){:root .lp-hero{height:auto}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
